import { ComplexEnum } from '../../../utils/complexEnum'
import { CAS, DS, CTS, FDC, Issue, EJ } from './instances'

export type InternalPayItemConnectionClassTypeItem =
  | typeof DS
  | typeof CAS
  | typeof CTS
  | typeof FDC
  | typeof Issue
  | typeof EJ
type ID = InternalPayItemConnectionClassTypeItem['id']

class InternalPayItemConnectionClassTypeEnum extends ComplexEnum<
  'InternalPayItemConnectionClassType',
  InternalPayItemConnectionClassTypeItem,
  ID
> {
  readonly typename = 'InternalPayItemConnectionClassType'
  DS = DS
  CAS = CAS
  CTS = CTS
  FDC = FDC
  Issue = Issue
  EJ = EJ
  get values() {
    return [this.DS, this.CAS, this.CTS, this.FDC, this.Issue, this.EJ]
  }
  fromClassType(classType: string) {
    return this.find((value) => value.classType === classType)
  }
  fromClassTypeOrFail(classType: string) {
    return this.orFail(this.fromClassType(classType), classType)
  }
}
/**
 * used to help resolve "internal" Pay Item connected modules in the Pay Items
 * Summary and Management pages
 */
export const InternalPayItemConnectionClassType =
  new InternalPayItemConnectionClassTypeEnum()
